import React from 'react';

import classes from './Button.css';

const button = (props) => {

  let btnClasses = [classes.Button];
  if (typeof props.btnType == "string") {
    btnClasses.push(classes[props.btnType]);
  } else {
    props.btnType.forEach(type => {
      btnClasses.push(classes[type]);
    });
  }

  if (props.extraClass) {
    btnClasses.push(props.extraClass);
  }

  return (
    <button
      className={btnClasses.join(' ')}
      disabled={props.disabled}
      onClick={props.clicked}
      style={props.style ? props.style : null}>{props.children}</button>
  );
};

export default button;



// WEBPACK FOOTER //
// ./src/components/UI/Button/Button.js